import React, { useState, useEffect } from 'react'; // Adicionado useEffect
import MaskedInput from 'react-text-mask';
// import ModernLayout from '../components/modern_layout'; // Removido
import ModernHeader from '../components/modern_header'; // Adicionado
import ModernCartSidebar from '../components/modern_cart_sidebar'; // Adicionado
import { useGlobalToast } from '../components/modern_toast';
import usePageTitle from '../hooks/usePageTitle';
import api from '../services/api';

function ModernLogin() {
  usePageTitle('Login');
  const [activeTab, setActiveTab] = useState('login');
  const [loading, setLoading] = useState(false);
  
  const [isFranqueado, setIsFranqueado] = useState(false);

  // --- ESTADOS DO CARRINHO ADICIONADOS ---
  const [carrinho, setCarrinho] = useState([]);
  const [cartSidebarOpen, setCartSidebarOpen] = useState(false);
  // --- FIM DA ADIÇÃO ---

  const [loginData, setLoginData] = useState({
    email: '', // Este campo será usado tanto para email quanto para CNPJ
    senha: ''
  });
  const [registerData, setRegisterData] = useState({
    nome: '',
    cpf: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    telefone: '',
    cep: '',
    endereco: '',
    cidade: '',
    estado: ''
  });
  const { addToast } = useGlobalToast();

  // --- FUNÇÃO DE CARRINHO (Baseada na ModernHome) ---
  const carrinhoDeCompras = async () => {
    try {
      console.log('🔄 INÍCIO carrinhoDeCompras - Login Page');
      // Na tela de login, o usuário NUNCA está logado ainda.
      // Então, sempre carregamos do sessionStorage.
      console.log('🔒 Carregando carrinho local (sessionStorage)...');
      const carrinhoList = [];
      const carrinhoStorage = sessionStorage.getItem('comprar');
      
      if (carrinhoStorage) {
        carrinhoStorage.split(';').forEach(element => {
          if (element && element.trim()) {
            try {
              const item = JSON.parse(element);
              if (item.quantidade !== undefined) {
                carrinhoList.push(item); // Formato moderno
              } else if (item.id) {
                // Converter formato antigo
                const itemModerno = {
                  id: item.id,
                  nome: item.nome || `Produto ${item.id}`,
                  preco: item[item.id]?.preco || 0,
                  quantidade: item[item.id]?.carrinho || 1,
                  img: item[item.id]?.img || '',
                  estoque: item[item.id]?.estoque || 0
                };
                carrinhoList.push(itemModerno);
              }
            } catch (error) {
              console.warn('⚠️ Erro ao parsear item do carrinho:', element, error);
            }
          }
        });
        setCarrinho(carrinhoList);
      } else {
        setCarrinho([]);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar carrinho:', error);
      setCarrinho([]);
    }
  };

  // useEffect para carregar o carrinho ao montar a página
  useEffect(() => {
    // Roda na primeira carga
    carrinhoDeCompras(); 

    // --- AJUSTE BFCache ---
    // Adiciona listener para recarregar o carrinho se a página for restaurada do bfcache
    const handlePageShow = (event) => {
      if (event.persisted) {
        console.log('🔄 BFCache restore detectado no Login. Recarregando carrinho...');
        // Apenas o carrinho precisa ser recarregado aqui
        carrinhoDeCompras();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
    // --- FIM AJUSTE BFCache ---
  }, []); // Roda apenas uma vez
  // --- FIM DA LÓGICA DE CARRINHO ---


  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFranqueadoChange = (e) => {
    const checked = e.target.checked;
    setIsFranqueado(checked);
    setLoginData(prev => ({
      ...prev,
      email: ''
    }));
  };

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegisterData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // FUNÇÃO handleLogin (versão revertida que você confirmou)
  const handleLogin = async (e) => {
    e.preventDefault();

    if (isFranqueado && loginData.email.includes('_')) {
        addToast('Por favor, preencha o CNPJ completo', 'error');
        return;
    }

    if (!loginData.email || !loginData.senha) {
      addToast('Por favor, preencha todos os campos', 'error');
      return;
    }

    try {
      setLoading(true);

      const dict_dados = {
        'acao': 'login', 
        'login': loginData.email,
        'senha_login': loginData.senha
      };

      const endpoint = isFranqueado ? 'login_loja' : 'login';
      
      const response = await api.post(endpoint, { dict_dados });

      if (response.data.login) {
        
        if (isFranqueado) {
          // Lógica de franqueado (sem cod_filial)
          const idLojaFranqueado = response.data.data.id_loja || response.data.data;

          sessionStorage.setItem('loja', idLojaFranqueado); 
          sessionStorage.setItem('login', '/' + idLojaFranqueado + '/');

          addToast('Login de franqueado realizado com sucesso!', 'success');

          setTimeout(() => {
            window.location.href = '/pedidos_loja/?loja='+ idLojaFranqueado;
          }, 500);

        } else {
          // Lógica de usuário normal
          sessionStorage.setItem('login', response.data.data);
          await addSessionToDb();
          addToast('Login realizado com sucesso!', 'success');
          
          const idLoja = sessionStorage.getItem('loja');
          setTimeout(() => {
            window.location.href = idLoja ? `/?id=${idLoja}` : '/';
          }, 500);
        }

      } else {
        const errorMsg = response.data.data || (isFranqueado ? 'CNPJ ou senha incorretos' : 'Email ou senha incorretos');
        addToast(errorMsg, 'error');
      }

    } catch (error) {
      console.error('Erro no login:', error);
      addToast('Erro ao fazer login. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };


  const handleRegister = async (e) => {
    e.preventDefault();

    // Validações
    if (!registerData.nome || !registerData.cpf || !registerData.email ||
        !registerData.telefone || !registerData.senha) {
      addToast('Por favor, preencha todos os campos obrigatórios', 'error');
      return;
    }

    if (registerData.senha !== registerData.confirmarSenha) {
      addToast('As senhas não coincidem', 'error');
      return;
    }

    if (registerData.senha.length < 6) {
      addToast('A senha deve ter pelo menos 6 caracteres', 'error');
      return;
    }

    if (registerData.cpf.includes('_')) {
      addToast('Por favor, complete o CPF', 'error');
      return;
    }

    if (registerData.telefone.includes('_')) {
      addToast('Por favor, complete o telefone', 'error');
      return;
    }

    try {
      setLoading(true);

      const dict_dados = {
        'acao': 'criar',
        'nome': registerData.nome,
        'cpf': registerData.cpf,
        'email': registerData.email,
        'telefone': registerData.telefone,
        'senha': registerData.senha
      };

      const response = await api.post('usuario', { dict_dados });

      if (response.data.criado) {
        sessionStorage.setItem('login', response.data.data);
        await addSessionToDb();
        addToast('Conta criada com sucesso!', 'success');

        const idLoja = sessionStorage.getItem('loja');
        setTimeout(() => {
          window.location.href = idLoja ? `/?id=${idLoja}` : '/';
        }, 500);
      } else {
        addToast(response.data.data || 'Erro ao criar conta', 'error');
      }

    } catch (error) {
      console.error('Erro no registro:', error);
      addToast('Erro ao criar conta. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const addSessionToDb = async () => {
    const dict_itens = {
      'usuario': sessionStorage.getItem('login'),
      'loja': sessionStorage.getItem('loja')
    };

    if (sessionStorage.getItem('favoritar')) {
      dict_itens['favoritar'] = sessionStorage.getItem('favoritar');
    }

    if (sessionStorage.getItem('comprar')) {
      const itensRaw = sessionStorage.getItem('comprar').split(';');
      for (const itemRaw of itensRaw) {
        if (!itemRaw) continue; 
        try {
          const dict = JSON.parse(itemRaw);
          const dict_para_enviar = {
            ...dict_itens, 
            'comprar': dict.id,
            'quantidade': dict.quantidade || 1
          };
          await api.post('add_session_db', { dict_itens: dict_para_enviar });
        } catch (e) {
          console.warn("Erro ao parsear item do carrinho durante addSessionToDb:", itemRaw, e);
        }
      }
    }
  };

  const handleForgotPassword = () => {
    if (!loginData.email) {
      addToast('Por favor, insira seu email primeiro', 'warning');
      return;
    }
    
    addToast('Instruções enviadas para seu email!', 'info');
  };

  // --- LAYOUT MODIFICADO ---
  return (
    <div className="main-container"> {/* 1. Substitui ModernLayout */}
      
      {/* 2. Adiciona o Header */}
      <ModernHeader 
        callback={null} // Sem busca na página de login
        cartItems={carrinho}
        onCartClick={() => setCartSidebarOpen(true)}
      />

      {/* 3. Adiciona o conteúdo da página (wrapper da home) */}
      <div className="modern-login-page container mt-5 mb-5"> {/* Adiciona container e margens */}
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="modern-login-card shadow-lg position-relative">
              <div className="card-body p-4">
                {/* Logo e título */}
                <div className="text-center mb-4">
                  <i className="bi bi-person-circle fs-1 text-primary mb-3"></i>
                  <h3 className="fw-bold">Bem-vindo!</h3>
                  <p className="text-muted">Entre em sua conta ou crie uma nova</p>
                </div>

                {/* Tabs */}
                <ul className="nav nav-pills nav-justified mb-4" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button 
                      className={`nav-link ${activeTab === 'login' ? 'active' : ''}`}
                      onClick={() => setActiveTab('login')}
                      type="button"
                    >
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      Entrar
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button 
                      className={`nav-link ${activeTab === 'register' ? 'active' : ''}`}
                      onClick={() => setActiveTab('register')}
                      type="button"
                    >
                      <i className="bi bi-person-plus me-2"></i>
                      Criar Conta
                    </button>
                  </li>
                </ul>

                {/* Conteúdo das tabs */}
                {activeTab === 'login' ? (
                  /* Tab de Login */
                  <form onSubmit={handleLogin}>
                    
                    {/* CHECKBOX FRANQUEADO */}
                    <div className="mb-3 form-check">
                      <input 
                        type="checkbox" 
                        className="form-check-input" 
                        id="franqueadoCheck"
                        checked={isFranqueado}
                        onChange={handleFranqueadoChange}
                      />
                      <label className="form-check-label" htmlFor="franqueadoCheck">Franqueado</label>
                    </div>

                    {/* CAMPO DE LOGIN CONDICIONAL (EMAIL OU CNPJ) */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        <i className={`bi ${isFranqueado ? 'bi-building' : 'bi-envelope'} me-2`}></i>
                        {isFranqueado ? 'CNPJ' : 'Email'}
                      </label>
                      
                      {isFranqueado ? (
                        <MaskedInput
                          mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                          className="form-control form-control-lg"
                          name="email"
                          value={loginData.email}
                          onChange={handleLoginChange}
                          placeholder="00.000.000/0000-00"
                          required
                          guide={false}
                        />
                      ) : (
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          name="email"
                          value={loginData.email}
                          onChange={handleLoginChange}
                          placeholder="seu@email.com"
                          required
                        />
                      )}
                    </div>

                    {/* CAMPO SENHA */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        <i className="bi bi-lock me-2"></i>
                        Senha
                      </label>
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        name="senha"
                        value={loginData.senha}
                        onChange={handleLoginChange}
                        placeholder="Sua senha"
                        required
                      />
                    </div>

                    {/* OPÇÕES DE LOGIN */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="lembrarMe" />
                        <label className="form-check-label" htmlFor="lembrarMe">
                          Lembrar-me
                        </label>
                      </div>
                      <button 
                        type="button"
                        className="btn btn-link p-0 text-decoration-none"
                        onClick={handleForgotPassword}
                      >
                        Esqueci minha senha
                      </button>
                    </div>

                    {/* BOTÃO SUBMIT */}
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-modern-login btn-lg"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                            Entrando...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-box-arrow-in-right me-2"></i>
                            Entrar
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                ) : (
                  /* Tab de Registro */
                  <form onSubmit={handleRegister}>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-person me-2"></i>
                          Nome Completo *
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="nome"
                          value={registerData.nome}
                          onChange={handleRegisterChange}
                          placeholder="Seu nome completo"
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-card-text me-2"></i>
                          CPF *
                        </label>
                        <MaskedInput
                          mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                          className="form-control"
                          placeholder="000.000.000-00"
                          name="cpf"
                          value={registerData.cpf}
                          onChange={handleRegisterChange}
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-telephone me-2"></i>
                          Telefone *
                        </label>
                        <MaskedInput
                          mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          className="form-control"
                          placeholder="(00) 00000-0000"
                          name="telefone"
                          value={registerData.telefone}
                          onChange={handleRegisterChange}
                          required
                        />
                      </div>

                      <div className="col-12 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-envelope me-2"></i>
                          Email *
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={registerData.email}
                          onChange={handleRegisterChange}
                          placeholder="seu@email.com"
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-lock me-2"></i>
                          Senha *
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="senha"
                          value={registerData.senha}
                          onChange={handleRegisterChange}
                          placeholder="Mínimo 6 caracteres"
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          <i className="bi bi-lock-fill me-2"></i>
                          Confirmar Senha *
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="confirmarSenha"
                          value={registerData.confirmarSenha}
                          onChange={handleRegisterChange}
                          placeholder="Repita a senha"
                          required
                        />
                      </div>

                    </div>

                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-modern-login btn-lg"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                            Criando conta...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-person-plus me-2"></i>
                            Criar Conta
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                )}

                {/* Divisor */}
                <div className="text-center mt-4">
                  <small className="text-muted">
                    Ao continuar, você concorda com nossos 
                    <a href="/termos" className="text-decoration-none ms-1">Termos de Uso</a>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4. Adiciona o Sidebar do Carrinho */}
      <ModernCartSidebar 
        isOpen={cartSidebarOpen}
        onClose={() => setCartSidebarOpen(false)}
        cartItems={carrinho}
        onUpdateCart={(updatedItems) => {
          setCarrinho(updatedItems);
          // Atualizar sessionStorage
          const sessao = updatedItems.map(item => JSON.stringify(item));
          sessionStorage.setItem('comprar', sessao.join(';'));
        }}
      />
    </div>
  );
}

export default ModernLogin;